import { combineReducers } from 'redux';

import containerReducer from './ducks/container';
import jobReducer from './ducks/job';
import embeddedContainerReducer from './ducks/embedded-container';
import fileReducer from './ducks/file';
import rawJobReducer from './ducks/rawJob';
import rootCausesReducer from './ducks/root-cause/reducers';

const reducers = {
  container: containerReducer,
  embeddedContainer: embeddedContainerReducer,
  job: jobReducer,
  files: fileReducer,
  rawJob: rawJobReducer,
  rootCause: rootCausesReducer,
};

export default combineReducers(reducers);
